import React from 'react'

import { AlignItems, Box, Display, FlexDirection } from '@gousto-internal/citrus-react'

import { OrderFeedBackConfirmation } from './OrderFeedBackConfirmation'
import { OrderFeedbackForm } from './OrderFeedbackForm'

type OrderFeedbackProps = {
  orderId: string
}

export const OrderFeedback = ({ orderId }: OrderFeedbackProps) => {
  const [score, setScore] = React.useState<number | undefined>(undefined)

  const handleSubmit = (selectedScore?: number) => {
    setScore(selectedScore)
  }

  return (
    <Box
      alignItems={AlignItems.Center}
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      gap={2}
      maxWidth="450px"
      paddingV={4}
    >
      {score ? (
        <OrderFeedBackConfirmation score={score} />
      ) : (
        <OrderFeedbackForm onSubmit={handleSubmit} orderId={orderId} />
      )}
    </Box>
  )
}
